import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useForm, ErrorMessage } from "react-hook-form";
import withSizes from 'react-sizes';

import { Container, Row, Col } from "deltoid/core/Blocks/BootstrapContainers";
import { Card } from "deltoid/core/OneDashCards";
import { H, Caption } from "deltoid/core/Blocks/Typography";
import Form from "deltoid/core/Form";

import SignUpCMS from "../../features/prismic/SignUpCMS";
import SignInPartnerCMS from "../../features/prismic/SignInPartnerCMS";
import config from "../../../shared/services/config";
import { fetchUser, clearUser } from '../../../shared/actions/auth';
import { UserResponse } from '../../../shared/utils/response';
import { emailRegex } from '../../../shared/services/validations';
import { fetchQueryParamsFromSession } from "../../../shared/services/utils";

import Hint from "../../../assets/svgs/hint.svg";


const GetStarted = (props) => {
  const { register, handleSubmit, errors, getValues, setValue, setError } = useForm({ mode: 'onChange' });
  const { user } = props;
  const [userFetched, setUserFetched] = useState(null);
  const [hideHint, setHidehint] = useState(false);
  const [isPartner, setIsPartner] = useState(config.get('product') === 'PARTNER' && true);

  useEffect(() => {
    const sessionParams = fetchQueryParamsFromSession();
    if (sessionParams && sessionParams.email) {
      const email = sessionParams.email;
      if (!emailRegex(email)) {
        setValue('email', email);
        fetchUserData();
      }
    }
  }, [])

  const onSubmit = async (formData) => {
    if (!user) {
      setError('email', 'regex', 'Wait for few seconds')
      return
    }
    try {
      const userData = UserResponse(props.user);
      let queryParams;
      let queryString = window.sessionStorage.getItem('queryString');
      if (userFetched && userData && Object.keys(userData).length == 0) {
        queryParams = queryString + `&email=${formData.email}`
        sessionStorage.setItem('queryString', queryParams);
        props.history.push({
          pathname: '/account/signup',
          state: {
            ...props.location.state,
              user: UserResponse(user),
          }
        });
      }
      else if (user && user.length > 0) {
          queryParams = queryString + `&email=${UserResponse(user).email}`
          sessionStorage.setItem('queryString', queryParams);
          props.history.push({
            pathname: '/account/signin',
            state: {
              ...props.location.state,
              user: UserResponse(user),
              userEmail: UserResponse(user).email,
              isLogin: true,
            }
          });
      }

    } catch (e) {
      console.log(e);
    }
  };

  const fetchUserData = async () => {
    try {
      const email = getValues('email');
      if (!emailRegex(email)) {
        await fetchUser(props.dispatch, { email })
        setUserFetched(true);
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  const clearUserData = async () => {
    try {
      await clearUser(props.dispatch);
      props.history.push({
        pathname: "/account/signin",
      })
    }
    catch (e) {
    }
  }

  return (
    <Container fluid className='vector-bg login-max-width-container'>
      <Row>
        <Col md={6} className='p-0'>
          {isPartner ? <SignInPartnerCMS /> : <SignUpCMS />}
        </Col>
        <Col md={5} className={props.isMobile && 'm-0 p-0'}>
          <div className={!props.isMobile && 'login-container mt-5 mx-4'}>
            <Card>
              <H level={5} variant="regular" className="pb-4 co-heading worksansregular-font">
                Let’s partner up
              </H>
              <Caption variant="light" className={props.isMobile ? 'pt-1 align-button-text pr-2' : 'align-button-text pr-3'}>
                Let’s level up your business with PayU Payments!
              </Caption>
              <form onSubmit={handleSubmit(onSubmit)} className='px-3 py-3'>
                <Row>
                 {!props.isMobile && !hideHint && 
                  <div style={{
                          position: "absolute",
                          width: "230px",
                          height: "75px",
                          left: "-150px",
                          top: "200px",
                          padding: "0",
                          background: "#EEF7FC"
                        }}
                    >
                      <Hint/>
                    </div>
                  }
                  <Form.Group className="position-relative mb-3">
                    <Form.Label id="email">
                      Enter your email id
                    </Form.Label>
                      <Form.Text
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Enter your email id"
                        ref={register({
                          required: "Email can not be empty",
                          validate: { regex: emailRegex },
                        })}
                        onChange={fetchUserData}
                        onFocus={() => setHidehint(true)}
                      />
                    <ErrorMessage errors={errors} name="email">
                      {({ message }) => (
                        <Form.Message
                          type="error"
                        >
                          {message}
                        </Form.Message>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                  
                </Row>
                <div className="d-flex flex-column-reverse row">
                  <div className="justify-content-end pt-3">
                    <Form.Button
                      type="submit"
                      className="w-100 mt-4 font-weight-bold rounded-btn"
                    >
                      Continue
                    </Form.Button>
                  </div>
                </div>
                <Row className="d-flex justify-content-center pt-2">
                  <Caption variant="light" className={props.isMobile ? 'pt-1 align-button-text pr-2' : 'align-button-text pr-3'}>
                    Already have an account?
                  </Caption>
                  <Form.Button
                    onClick={clearUserData}
                    variant="underlined"
                  >
                    Login
                  </Form.Button>
                </Row>
              </form>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const mapStateToProps = (state) => {
  return {
    user: state.session.User.data.data,
  };
};

const Responsive = withSizes(mapSizesToProps)(GetStarted);
export default connect(mapStateToProps, mapDispatchToProps)(Responsive);